<template>
  <div class="bggray" @click="optionActive = false">
    <app-header />
    <div class="orderWrap">
      <div class="orderNav">
        <span class="cur">确认购买信息</span>
        <span>选择支付方式</span>
        <span>购买成功</span>
      </div>
      <div class="mod orderInfo">
        <h3 class="title">订单详情</h3>
        <ul class="column3">
          <li>
            <div>产品名称</div>
            <div>数量</div>
            <div>小计</div>
          </li>
          <li>
            <div>
              <p v-if="product.spu">{{product.spu.name}}</p>
            </div>
            <div class="select">
              <!-- <el-select v-model="stockUnit" placeholder="请选择" style="width:150px">
                <el-option
                  v-for="item in product.skuList"
                  :key="item.stockUnit"
                  :label="item.oriPrice | amountUnitFormat(item.month)"
                  :value="item.stockUnit"
                ></el-option>
              </el-select> -->
              <p v-text="buynum"></p>
            </div>
            <div
              v-for="item in product.skuList"
              :key="item.stockUnit"
              v-show="item.stockUnit === stockUnit"
            >¥ {{item.oriPrice}}</div>
          </li>
        </ul>
        <div class="totalLine">
          <div class="note-r">
            <p class="totalMoney">
              <span>支付金额总计：</span>
              <strong
                v-for="item in product.skuList"
                :key="item.id"
                v-show="item.stockUnit === stockUnit"
              >{{ item.curPrice }}</strong>
              <em>元</em>
            </p>
            <p>
              <span>已优惠：</span>
              <em
                v-for="item in product.skuList"
                :key="item.id"
                v-show="item.stockUnit === stockUnit"
              >{{item.curPrice - item.oriPrice}} 元</em>
            </p>
          </div>
        </div>
      </div>
      <!-- 购买协议组件 -->
      <!-- <div class="license">
        <h3 class="title">
          <span>
            <router-link to="/protocol" target="_blank">使用软件产品许可协议</router-link>
          </span>
          <p>
            <i
              class="icon-right"
              @click="cancelActive = !cancelActive"
              :class="{cancel:cancelActive}"
            ></i>我已仔细阅读相关协议，对其内容表示确认
          </p>
        </h3>
      </div> -->
      <div class="mod invoice address">
        <h3 class="title">收货地址</h3>
        <template v-if="JSON.stringify(delivery) != '{}'">
          <p>收件人：{{delivery.consignee}}</p>
          <p>电话：{{delivery.consigneePhone}}</p>
          <p>地址：{{delivery.province}}{{delivery.city}}{{delivery.region}}{{delivery.address}}</p>
        </template>
        <p>
          <!-- <span>{{newAddress != '' ? newAddress : '收获地址未填'}}</span> -->
          <em class="modify" @click="openInvoice">修改</em>
        </p>
        <a class="confirmBtn" @click="orderConfirm">确认订单</a>
        <!-- 收货地址组件 -->
        <Address  @getAddress="getAddress" ref="address" />
      </div>
    </div>
    <!-- <app-footer /> -->
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
// import AppFooter from "@/components/common/AppFooter.vue";
import Protocol from "@/components/protocol/Protocol.vue";
import Address from '@/components/invoice/Address.vue';

export default {
  data() {
    return {
      product: {},
      spuId: this.$route.params.spuId,
      stockUnit: this.$route.params.stockUnit,
      buynum: 1+'/'+ this.$route.params.stockUnit,
      cancelActive: false,
      invoiceTitleType: 1,
      delivery: {}
    };
  },
  created() {
    document.title="上海大智慧信息科技网上商城"
    var month = this.$route.params.month;
    if (month) {
      this.month = Number(month);
    }
    this.getProduct();
  },
  mounted() {
    // this.invoiceTitleType = this.$refs.invoice.invoiceTitleType;
  },

  computed: {
    
  },
  methods: {
    getProduct() {
      var params = {
        spuId: this.spuId
      };
      this.$get("/order/v1/confirm", params)
        .then(response => {
          if (response.code === 0) {
            this.product = response.data.goods;
            response.data.delivery && (this.delivery = response.data.delivery)
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
    openInvoice() {
      //调用子组件发票抬头类型
      this.$refs.address.openInvoice();
    },
    changeInvoiceTitleType(invoiceTitleType) {
      //获取发票组件发票抬头类型
      this.invoiceTitleType = invoiceTitleType;
    },
    orderConfirm() {
      // 保存订单并跳转到支付页面
      var params = {
        spuId: this.spuId,
        skuId: this.product.skuList[0].id
      };
      if (this.delivery) {
        params.deliveryId = this.delivery.id;
      }
      this.$post("/order/v1/save", params)
        .then(response => {
          if (response.code === 0) {
            this.$router.push("/order/pay/" + response.data.id);
          } else if(response.code === 1) {
            this.$global.alert("请输入地址")
          }
          else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
    getAddress(val) {
      let params  = val;
      this.$post("/delivery/v1/save",params)
        .then(res=>{
          if(res.code === 0) {
            this.delivery = {
              ...this.delivery,
              ...res.data
            }
            this.getProduct();
          }
        })
        .catch(res=>{
          this.$global.alertError()
        })
    }
  },
  components: {
    AppHeader,
    // AppFooter,
    Protocol,
    Address
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/scss/order.scss";
.totalLine {
  overflow: hidden;
  color: #666;
}
.totalLine .note {
  font-size: 14px;
  float: left;
  margin: 10px 0 0 35px;
}
.totalLine .note-r {
  float: right;
  font-size: 16px;
}
.totalLine .note-r p {
  margin-bottom: 10px;
}
.totalLine .note-r p span {
  margin-right: 20px;
}
.totalLine .note-r p:nth-child(2) span {
  float: left;
}
.totalLine .note-r p:nth-child(2) em {
  display: block;
  text-align: right;
}
.totalLine .totalMoney strong {
  font-size: 30px;
  color: #166fff;
}
.totalLine .totalMoney em {
  font-size: 18px;
  color: #166fff;
}
.invoice .title + p span {
  margin-right: 20px;
}
.orderWrap .invoice {
  position: relative;
  padding-bottom: 50px;
}
.invoice .modify {
  color: #166fff;
  cursor: pointer;
}
.invoice .confirmBtn {
  position: absolute;
  top: 60px;
  right: 100px;
  background: #166fff;
  border-radius: 4px;
  width: 163px;
  height: 52px;
  line-height: 52px;
  text-align: center;
  font-size: 22px;
  color: #fff;
  display: block;
}
.invoice .confirmBtn:hover {
  background: #1460db;
}
.invoice .title + p {
  padding-left: 35px;
}
.address p{
  margin-bottom: 5px;
}
.address .title + p{
  padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/OrderConfirm.vue